<app-data-listing-provider (onActionClickedSetRowData)="onSetRowData($event)" />
